import React from 'react';

// Premium Logo Component - Uses SVG logo with gold gradient
// Sizes: sm, md, lg, xl
// Variants: 'full' (icon + text), 'text' (only text), 'icon' (only image)
export const Logo = ({ size = 'md', variant = 'full', className = '' }) => {
  const sizes = {
    sm: { icon: 'h-12', title: 'text-xl', subtitle: 'text-[10px]' },
    md: { icon: 'h-16', title: 'text-2xl', subtitle: 'text-[11px]' },
    lg: { icon: 'h-20', title: 'text-3xl', subtitle: 'text-xs' },
    xl: { icon: 'h-24', title: 'text-4xl', subtitle: 'text-sm' },
  };
  const s = sizes[size];

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      {variant !== 'text' && (
        <div className="relative flex-shrink-0">
          {/* Ambient glow */}
          <div className="absolute inset-0 bg-gradient-to-br from-[#C5A05E]/25 to-[#D4B06E]/15 rounded-2xl blur-xl animate-pulse" style={{ animationDuration: '4s' }} />
          
          {/* Premium SVG logo */}
          <img
            src="/logo-premium.svg"
            alt="Kaya Group Property Management"
            className={`${s.icon} w-auto object-contain relative z-10 drop-shadow-[0_0_12px_rgba(197,160,94,0.35)]`}
          />
        </div>
      )}
      
      {variant === 'text' && (
        <div className="flex flex-col">
          <span className={`${s.title} font-bold bg-gradient-to-r from-[#E8C77E] via-[#D4B06E] to-[#C5A05E] bg-clip-text text-transparent tracking-tight leading-none`}
                style={{ fontFamily: "'Great Vibes', cursive", fontStyle: 'italic' }}>
            Kaya
          </span>
          <span className={`${s.subtitle} text-[#C5A05E]/80 uppercase tracking-[0.25em] font-semibold mt-1`}>
            Property Management
          </span>
        </div>
      )}
    </div>
  );
};

export default Logo;
